import { T } from "@freightsimple/ui-core/Typography/T";
import PageTitle from "@/Shared/Layout/PageTitle";

function BookShipmentError() {
  return (
    <>
      <PageTitle>Nearly there</PageTitle>
      <div className="flex flex-col items-center">
        <div className="h-[51px]" />
        <T size="base" weight="medium" align="center">
          Nearly there! Looks like this shipment needs a little help to finish
          booking.
        </T>
        <div className="h-[60px]" />
        <img width="180" src="/waiting-truck.png" alt="Waiting truck" />
        <div className="h-[60px]" />
        <T size="base" weight="normal" color="secondary" align="center">
          Our team will finish the job and contact you with your documents
          within the next 60 minutes.
        </T>
        <div className="h-[15px]" />
      </div>
    </>
  );
}
export default BookShipmentError;
